module.exports = __webpack_public_path__ + "static/img/scroll-top@3x.ff4dd262.png";